
<div class="padding-20 ui-g" id="c3_searchProducts_Modal">
 
   
   <!-- Bottoni Annulla e Aggiungi -->
 
   <div class="ui-dialog-footer fixed-buttons buttonsContainer">
     <button pButton (click)="onClickAnnullaProducts()" type="button" class="k-generic-btn footer-btn" label="{{'common.cancel' | translate}}"></button>
     <button pButton type="button" (click)="onClickAggiungiProducts()" type="button" class="k-generic-btn footer-btn" label="{{'common.add' | translate}}"></button>
     <div class="clear_fix"></div>
   </div>
   
  <br />
  <br />
  <br />

<!-- KS-7308 -->
  <app-campaign-3-kontable 
  *ngIf="show.table"
  id="productsListTable"            
  [columns] = "[         
  { field: 'code', title: 'campaign.code' },
  { field: 'description', title: 'campaign.description' },
  { field: 'product_categories', title: 'campaign.category' },
  { field: 'product_department', title: 'campaign.department' },
  { field: 'barcode', title: 'campaign.barcode' }
]"
     
  [paginationType]="paginationType"
  [showInfoButton]="false"            
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showRecoverButton]="false"
  [showAddButton]="false"
  [showDeleteButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [allowSelectRow]="false"
  [showSelectButton]="true"
  (onSelected)="onProductsSelected($event)"
  (onRefresh)="onRefreshTable($event)"
  (onTableRendered)="onTableRendered($event)"
  [service]="srvCampaign"
  [rowSelected]="rowSelected"
  [methodsNames]="{ list: 'getProductItemComplete', sendExtSearchQuery: 'sendExtSearchQuery' }"
  #productsListTable>


</app-campaign-3-kontable>  
 
</div>


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-products/campaign-3-search-products.component.html